/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateVendorErrorCodeRequestDto,
  ListVendorErrorCodesResponseDto,
  ReopenVendorErrorCodeRequestDto,
  UpdateVendorErrorCodeRequestDto,
  VendorErrorCodeResponseDto,
} from '../models/index';
import {
    CreateVendorErrorCodeRequestDtoFromJSON,
    CreateVendorErrorCodeRequestDtoToJSON,
    ListVendorErrorCodesResponseDtoFromJSON,
    ListVendorErrorCodesResponseDtoToJSON,
    ReopenVendorErrorCodeRequestDtoFromJSON,
    ReopenVendorErrorCodeRequestDtoToJSON,
    UpdateVendorErrorCodeRequestDtoFromJSON,
    UpdateVendorErrorCodeRequestDtoToJSON,
    VendorErrorCodeResponseDtoFromJSON,
    VendorErrorCodeResponseDtoToJSON,
} from '../models/index';

export interface VendorErrorCodeControllerCreateRequest {
    createVendorErrorCodeRequestDto: CreateVendorErrorCodeRequestDto;
}

export interface VendorErrorCodeControllerDeleteRequest {
    id: string;
}

export interface VendorErrorCodeControllerFindAllRequest {
    limit: number;
    page: number;
    sortOrder?: VendorErrorCodeControllerFindAllSortOrderEnum;
    manufacturerId?: string;
    q?: string;
}

export interface VendorErrorCodeControllerFindByIdRequest {
    id: string;
}

export interface VendorErrorCodeControllerReopenRequest {
    id: string;
    reopenVendorErrorCodeRequestDto: ReopenVendorErrorCodeRequestDto;
}

export interface VendorErrorCodeControllerUpdateRequest {
    id: string;
    updateVendorErrorCodeRequestDto: UpdateVendorErrorCodeRequestDto;
}

/**
 * 
 */
export class ErrorManagementVendorErrorCodesApi extends runtime.BaseAPI {

    /**
     */
    async vendorErrorCodeControllerCreateRaw(requestParameters: VendorErrorCodeControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VendorErrorCodeResponseDto>> {
        if (requestParameters['createVendorErrorCodeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createVendorErrorCodeRequestDto',
                'Required parameter "createVendorErrorCodeRequestDto" was null or undefined when calling vendorErrorCodeControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/vendor-error-codes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateVendorErrorCodeRequestDtoToJSON(requestParameters['createVendorErrorCodeRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VendorErrorCodeResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async vendorErrorCodeControllerCreate(requestParameters: VendorErrorCodeControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VendorErrorCodeResponseDto> {
        const response = await this.vendorErrorCodeControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async vendorErrorCodeControllerDeleteRaw(requestParameters: VendorErrorCodeControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vendorErrorCodeControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/vendor-error-codes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async vendorErrorCodeControllerDelete(requestParameters: VendorErrorCodeControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vendorErrorCodeControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async vendorErrorCodeControllerFindAllRaw(requestParameters: VendorErrorCodeControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListVendorErrorCodesResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling vendorErrorCodeControllerFindAll().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling vendorErrorCodeControllerFindAll().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['manufacturerId'] != null) {
            queryParameters['manufacturerId'] = requestParameters['manufacturerId'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/vendor-error-codes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListVendorErrorCodesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async vendorErrorCodeControllerFindAll(requestParameters: VendorErrorCodeControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListVendorErrorCodesResponseDto> {
        const response = await this.vendorErrorCodeControllerFindAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async vendorErrorCodeControllerFindByIdRaw(requestParameters: VendorErrorCodeControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VendorErrorCodeResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vendorErrorCodeControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/vendor-error-codes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VendorErrorCodeResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async vendorErrorCodeControllerFindById(requestParameters: VendorErrorCodeControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VendorErrorCodeResponseDto> {
        const response = await this.vendorErrorCodeControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async vendorErrorCodeControllerReopenRaw(requestParameters: VendorErrorCodeControllerReopenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vendorErrorCodeControllerReopen().'
            );
        }

        if (requestParameters['reopenVendorErrorCodeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'reopenVendorErrorCodeRequestDto',
                'Required parameter "reopenVendorErrorCodeRequestDto" was null or undefined when calling vendorErrorCodeControllerReopen().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/vendor-error-codes/{id}/reopen`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReopenVendorErrorCodeRequestDtoToJSON(requestParameters['reopenVendorErrorCodeRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async vendorErrorCodeControllerReopen(requestParameters: VendorErrorCodeControllerReopenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vendorErrorCodeControllerReopenRaw(requestParameters, initOverrides);
    }

    /**
     */
    async vendorErrorCodeControllerUpdateRaw(requestParameters: VendorErrorCodeControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VendorErrorCodeResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vendorErrorCodeControllerUpdate().'
            );
        }

        if (requestParameters['updateVendorErrorCodeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateVendorErrorCodeRequestDto',
                'Required parameter "updateVendorErrorCodeRequestDto" was null or undefined when calling vendorErrorCodeControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/vendor-error-codes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateVendorErrorCodeRequestDtoToJSON(requestParameters['updateVendorErrorCodeRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VendorErrorCodeResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async vendorErrorCodeControllerUpdate(requestParameters: VendorErrorCodeControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VendorErrorCodeResponseDto> {
        const response = await this.vendorErrorCodeControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const VendorErrorCodeControllerFindAllSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type VendorErrorCodeControllerFindAllSortOrderEnum = typeof VendorErrorCodeControllerFindAllSortOrderEnum[keyof typeof VendorErrorCodeControllerFindAllSortOrderEnum];
